import Tracker from './tracker'

export const tracker = new Tracker()
